module.exports = __webpack_public_path__ + "img/screen-6.e110b7a6.jpg";